/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLuckylotteryItems.vue?vue&type=template&id=ab246c8e&scoped=true"
import script from "./popLuckylotteryItems.vue?vue&type=script&lang=js"
export * from "./popLuckylotteryItems.vue?vue&type=script&lang=js"
import style0 from "./popLuckylotteryItems.vue?vue&type=style&index=0&id=ab246c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab246c8e",
  null
  
)

export default component.exports